import "./App.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../Auth/Login/Login";
import Register from "../Auth/Register/Register";
import ForgotPassword from "../Auth/ForgotPassword/ForgotPassword";
import LandingScreen from "../LandingScreen/LandingScreen";
import ErrorPage from "../ErrorPage/ErrorPage";
import Homepage from "../Homepage/Homepage";
import MessagesPage from "../MessagesPage/MessagesPage";
import MoodOverviewPage from "../MoodOverviewPage/MoodOverviewPage";
import MoodDetailStudent from "../MoodOverviewPage/MoodDetailStudent";
import ChangePassword from "components/ProfilePage/ChangePassword";
import MyProfile from "components/ProfilePage/MyProfile";
import ContactUs from "components/ContactUsPage/ContactUs";

function App() {
  return (
    <div className="app">
      <div className="app__body">
        <Routes>
          <Route path="/" element={<LandingScreen />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/messages/:id" element={<MessagesPage />} />
          <Route path="/mood-overview" element={<MoodOverviewPage />} />
          <Route path="/mood-overview/:id" element={<MoodDetailStudent />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/errorpage" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
